import React, { useEffect, useState } from 'react';
import { api, fmt } from '../utils/api';
import Topbar from '../components/Topbar';
import { Badge, EmptyState, Spinner, SearchInput, useToast, Modal } from '../components/UI';
const CHECKBOXES = [
  { key:'ilaSignedFranchisee', label:'ILA (Franchisee)' },
  { key:'ilaSignedInvestor',   label:'ILA (Investor)' },
  { key:'contractSigned',      label:'Franchise Contract' },
  { key:'bankAccountOpened',   label:'Bank Account' },
  { key:'companyCreated',      label:'Company Created' },
];
const COLUMNS = [
  { key:'not_interested', label:'Not Interested',  color:'var(--red)',           accent:'#cf6679', bg:'rgba(163,45,45,0.05)' },
  { key:'potential',      label:'Potential',       color:'var(--text-tertiary)', accent:'#888780', bg:'rgba(136,135,128,0.08)' },
  { key:'signed',         label:'Signed',          color:'var(--blue)',          accent:'#378ADD', bg:'rgba(55,138,221,0.06)' },
  { key:'active',         label:'Active',          color:'var(--green)',         accent:'#639922', bg:'rgba(99,153,34,0.06)' },
  { key:'closed',         label:'Closed',          color:'var(--text-tertiary)', accent:'#888780', bg:'rgba(136,135,128,0.05)' },
];
function emptyPerson(type) {
  return type === 'investor'
    ? { name:'', type:'individual', companyName:'', email:'', phone:'', sharePercent:'', paying:'' }
    : { name:'', email:'', phone:'', sharePercent:'', paying:'' };
}
function emptyEntry() {
  return {
    companyName:'', location:'', status:'potential', franchiseCost:'', paymentPlan:'',
    paymentInstallments:[],
    ilaSignedFranchisee:false, ilaSignedInvestor:false, contractSigned:false,
    bankAccountOpened:false, companyCreated:false, notes:'', commentLog:'', _newComment:'',
    franchisees:[{ name:'', email:'', phone:'', sharePercent:'', paying:'' }],
    investors:[],
  };
}
function getInitials(name) {
  if (!name) return '?';
  return name.split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase();
}
const AVATAR_COLORS = ['#B5D4F4:#0C447C','#9FE1CB:#085041','#FAC775:#633806','#CECBF6:#3C3489','#F5C4B3:#712B13','#C0DD97:#27500A'];
function avatarColor(idx) {
  const pair = AVATAR_COLORS[idx % AVATAR_COLORS.length].split(':');
  return { bg:pair[0], color:pair[1] };
}


function ActiveModal({ pipelineId, companyName, location, franchisees, onConfirm, onCancel }) {
  const [users, setUsers] = React.useState([]);
  React.useEffect(() => { api.getUsers().then(u => setUsers(u||[])); }, []);
  const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const now = new Date();
  const monthOpts = [];
  const futureDate = new Date(now.getFullYear(), now.getMonth() + 6);
  for (let y = 2024; y <= futureDate.getFullYear(); y++) {
    const endM = y === futureDate.getFullYear() ? futureDate.getMonth() : 11;
    for (let m = 0; m <= endM; m++) {
      monthOpts.push(MONTHS[m] + ' ' + y);
    }
  }
  const [royaltyStart, setRoyaltyStart] = React.useState('');
  const [hocUser, setHocUser] = React.useState('');
  const franchiseeUsers = users.filter(u => u.role === 'franchisee' || u.role === 'admin' || u.role === 'hq_support');
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', zIndex:500, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ background:'#fff', borderRadius:'var(--r-lg)', width:'100%', maxWidth:460, padding:28, boxShadow:'0 20px 60px rgba(0,0,0,0.2)' }}>
        <div style={{ fontSize:16, fontWeight:700, color:'var(--navy)', marginBottom:6 }}>Move to Active</div>
        <div style={{ fontSize:13, color:'var(--text-secondary)', marginBottom:20 }}>
          Moving <strong>{companyName}</strong> to Active will create the branch and user accounts.
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
          <div>
            <label>ROYALTY START MONTH *</label>
            <select value={royaltyStart} onChange={e=>setRoyaltyStart(e.target.value)}>
              <option value="">— Select month —</option>
              {monthOpts.reverse().map(m=><option key={m} value={m}>{m}</option>)}
            </select>
          </div>
          <div>
            <label>HEAD OF CENTRE (HOC)</label>
            <select value={hocUser} onChange={e=>setHocUser(e.target.value)}>
              <option value="">— Select HoC (optional) —</option>
              {franchisees.filter(f=>f.name&&f.email).map((f,i) => {
                const matchedUser = users.find(u => (u.email||'').toLowerCase() === (f.email||'').toLowerCase());
                if (matchedUser) return <option key={i} value={matchedUser.id}>{matchedUser.name} ({matchedUser.email})</option>;
                return <option key={i} value={f.email}>{f.name} ({f.email}) — not yet registered</option>;
              })}
              {users.filter(u => !franchisees.some(f => (f.email||'').toLowerCase() === (u.email||'').toLowerCase()) && (u.role==='franchisee'||u.role==='director')).map((u,i) => (
                <option key={'other-'+i} value={u.id}>{u.name} ({u.email}) — other user</option>
              ))}
            </select>
            <div style={{ fontSize:11, color:'var(--text-tertiary)', marginTop:4 }}>Select which franchisee is the Head of Centre</div>
          </div>
        </div>
        <div style={{ display:'flex', gap:8, marginTop:24 }}>
          <button className="btn btn-secondary" style={{ flex:1 }} onClick={onCancel}>Cancel</button>
          <button className="btn btn-primary" style={{ flex:1 }} disabled={!royaltyStart} onClick={()=>onConfirm(royaltyStart, hocUser)}>Create Active Branch</button>
        </div>
      </div>
    </div>
  );
}

function AddComment({ pipelineId, user, onSave }) {
  const [text, setText] = React.useState('');
  const [saving, setSaving] = React.useState(false);
  return (
    <div style={{ marginBottom:8 }}>
      <div style={{ fontSize:10, fontWeight:700, color:'var(--text-tertiary)', letterSpacing:'0.07em', marginBottom:4 }}>ADD COMMENT</div>
      <div style={{ display:'flex', gap:6 }}>
        <textarea
          value={text}
          onChange={e => setText(e.target.value)}
          placeholder="Write a comment..."
          rows={2}
          style={{ flex:1, resize:'none', fontSize:12 }}
        />
        <button
          className="btn btn-sm btn-primary"
          style={{ alignSelf:'flex-end', whiteSpace:'nowrap', fontSize:11 }}
          disabled={saving || !text.trim()}
          onClick={async () => {
            if (!text.trim()) return;
            setSaving(true);
            await onSave(text.trim());
            setText('');
            setSaving(false);
          }}>
          {saving ? '...' : 'Add'}
        </button>
      </div>
    </div>
  );
}

export default function Pipeline({ user }) {
  const [pipeline, setPipeline] = useState([]);
  const [loading, setLoading] = useState(true);
  const [collapsedCols, setCollapsedCols] = useState({ not_interested: true });
  const [search, setSearch] = useState('');
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(emptyEntry());
  const [showToast, Toast] = useToast();
  const [expandedId, setExpandedId] = useState(null);
  const [dragId, setDragId] = useState(null);
  const [dragOver, setDragOver] = useState(null);
  const [complianceMap, setComplianceMap] = useState({});
  const [activeModal, setActiveModal] = useState(null); // { pipelineId, companyName, location, franchisees }
  const isAdmin = user?.role === 'admin' || user?.role === 'hq_support';
  // isPipelineViewer: hq_support with pipeline access but NOT full admin permissions
  const _perms = (() => { try { return typeof user?.permissions === 'string' ? JSON.parse(user.permissions) : (user?.permissions||{}); } catch(e) { return {}; } })();
  const isPipelineViewer = user?.role === 'hq_support' && !!_perms.view_pipeline && !(_perms.view_declarations || _perms.view_branches || _perms.view_royalties || _perms.view_approvals);
  useEffect(() => { load(); }, []);
  // Live compliance sync when modal opens
  useEffect(() => {
    if (!modal) return;
    const emails = (form.franchisees||[]).map(fr => (fr.email||'').toLowerCase().trim()).filter(Boolean);
    if (!emails.length) return;
    let cancelled = false;
    (async () => {
      try {
        const allUsers = await api.getUsers();
        const matches = (allUsers||[]).filter(u => emails.includes((u.email||'').toLowerCase().trim()));
        const results = await Promise.all(matches.map(u => api.getCompliance(u.id).catch(() => null)));
        if (cancelled) return;
        const map = {};
        matches.forEach((u, idx) => {
          const docs = results[idx]?.documents || [];
          const byType = {};
          docs.forEach(d => { byType[d.docType] = d.fileName; });
          map[(u.email||'').toLowerCase().trim()] = byType;
        });
        setComplianceMap(map);
      } catch(e) {}
    })();
    return () => { cancelled = true; };
  }, [modal, form.franchisees]);
  function load() { api.getPipeline().then(p => { setPipeline(p||[]); setLoading(false); }); }
  function updateFranchisee(i,k,v) { setForm(f=>({...f,franchisees:f.franchisees.map((x,j)=>j===i?{...x,[k]:v}:x)})); }
  function updateInvestor(i,k,v) { setForm(f=>({...f,investors:f.investors.map((x,j)=>j===i?{...x,[k]:v}:x)})); }
  async function save() {
    if (isPipelineViewer) { showToast('You do not have permission to edit'); return; }
    if (!form.companyName) { showToast('Company name required'); return; }
    const isNew = modal.mode === 'new';
    if (isNew) {
      const { _newComment: _nc, ...formToCreate } = form; await api.createPipeline(formToCreate);
      await api.logActivity('Added pipeline entry', `${form.companyName} — ${form.location||'TBC'} — Status: ${form.status}`);
    } else {
      const prev = pipeline.find(p => p.id === form.id);
      const changes = [];
      if (prev?.status !== form.status) changes.push(`Status: ${prev?.status} → ${form.status}`);
      if (prev?.companyName !== form.companyName) changes.push('Name changed');
      const { _newComment, ...formToSave } = form;
      const cleanForm = {...formToSave,
        ilaSignedFranchisee:!!formToSave.ilaSignedFranchisee,
        ilaSignedInvestor:!!formToSave.ilaSignedInvestor,
        contractSigned:!!formToSave.contractSigned,
        bankAccountOpened:!!formToSave.bankAccountOpened,
        companyCreated:!!formToSave.companyCreated,
      };
      await api.updatePipeline(cleanForm.id, cleanForm);
      await api.logActivity('Updated pipeline entry', `${form.companyName}${changes.length?' — '+changes.join('; '):''}`);
    }
    showToast(isNew ? 'Entry added' : 'Entry updated');
    setModal(null); load();
  }
  async function del(p) {
    if (!window.confirm(`Delete ${p.companyName}?`)) return;
    await api.deletePipeline(p.id);
    await api.logActivity('Deleted pipeline entry', p.companyName);
    showToast('Deleted'); load();
  }
  async function moveToStatus(id, newStatus) {
    const p = pipeline.find(x => x.id === id);
    if (!p || p.status === newStatus) return;
    // Auto-create on signed
    if (newStatus === 'signed' && p.status !== 'signed') {
      try {
        await handleSignedAutoCreate(p);
      } catch(e) {
        showToast('Warning: auto-create failed — ' + (e.message||'unknown error'));
      }
    }
    // Prompt for HOC/royalty on active
    if (newStatus === 'active' && p.status !== 'active') {
      setActiveModal({ pipelineId: id, companyName: p.companyName, location: p.location, franchisees: p.franchisees||[] });
      return; // don't update status yet — modal will handle it
    }
    await api.updatePipeline(id, { ...p, status: newStatus });
    await api.logActivity('Pipeline status changed', `${p.companyName} → ${newStatus}`);
    load();
  }

  async function handleSignedAutoCreate(p) {
    // Create the franchise branch
    const franchiseData = {
      name: p.companyName,
      location: p.location || p.companyName,
      status: 'signed',
      royaltyStartMonth: '',
      phone: '',
      email: '',
      owners: (p.franchisees||[]).filter(f=>f.name&&f.email).map(f=>({ name:f.name, email:f.email, phone:f.phone||'', sharePercent:f.sharePercent||'0' })),
      investors: (p.investors||[]).filter(f=>f.name&&f.email).map(f=>({ name:f.name, email:f.email, phone:f.phone||'', sharePercent:f.sharePercent||'0' }))
    };
    const franchise = await api.createFranchise(franchiseData);
    await api.logActivity('Auto-created branch from pipeline', p.companyName);
    // Create user accounts for each franchisee
    const allUsers = await api.getUsers();
    for (const fr of (p.franchisees||[]).filter(f=>f.name&&f.email)) {
      let existingUser = (allUsers||[]).find(u => (u.email||'').toLowerCase() === (fr.email||'').toLowerCase());
      if (!existingUser) {
        const newUser = await api.createUser({ name:fr.name, email:fr.email, phone:fr.phone||'', password:'GoTutors2026!', role:'franchisee' });
        if (newUser?.id) {
          await api.sendWelcomeEmail(newUser.id);
          await api.logActivity('Auto-created franchisee user from pipeline', `${fr.name} (${fr.email})`);
        }
      }
    }
    showToast(`✓ Branch and user accounts created for ${p.companyName}`);
  }

  async function handleActiveCreate(pipelineId, royaltyStartMonth, hocEmail) {
    const p = pipeline.find(x => x.id === pipelineId);
    if (!p) return;
    try {
      // Check if branch already exists (created when moved to Signed)
      const allFranchises = await api.getFranchises();
      const existingFranchise = (allFranchises||[]).find(f =>
        (f.name||'').toLowerCase() === (p.companyName||'').toLowerCase() ||
        (f.location||'').toLowerCase() === (p.location||'').toLowerCase()
      );
      if (existingFranchise) {
        // Update existing branch to active with royalty start and HOC
        // hocEmail could be a user ID or an email address
        const allUsers = await api.getUsers();
        const hocUserObj = hocEmail ? (
          (allUsers||[]).find(u => u.id === hocEmail) ||
          (allUsers||[]).find(u => (u.email||'').toLowerCase() === (hocEmail||'').toLowerCase())
        ) : null;
        const hocUserId = hocUserObj?.id || null;
        await api.updateFranchise(existingFranchise.id, {
          name: existingFranchise.name,
          location: existingFranchise.location,
          email: existingFranchise.email || '',
          phone: existingFranchise.phone || '',
          status: 'active',
          royaltyStartMonth: royaltyStartMonth || null,
          headOfCentre: hocUserId,
          closedDate: existingFranchise.closedDate || null
        });
        await api.logActivity('Updated branch to active from pipeline', p.companyName);
        showToast(`✓ ${p.companyName} branch updated to Active`);
      } else {
        // No existing branch — create new one
        const allUsers = await api.getUsers();
        const hocUser = hocEmail ? (allUsers||[]).find(u => u.id === hocEmail) : null;
        const franchiseData = {
          name: p.companyName,
          location: p.location || p.companyName,
          status: 'active',
          royaltyStartMonth,
          headOfCentre: hocEmail || null,
          phone: '', email: '',
          owners: (p.franchisees||[]).filter(f=>f.name&&f.email).map(f=>({ name:f.name, email:f.email, phone:f.phone||'', sharePercent:f.sharePercent||'0' })),
          investors: (p.investors||[]).filter(f=>f.name&&f.email).map(f=>({ name:f.name, email:f.email, phone:f.phone||'', sharePercent:f.sharePercent||'0' }))
        };
        await api.createFranchise(franchiseData);
        await api.logActivity('Auto-created active branch from pipeline', p.companyName);
        // Create user accounts
        for (const fr of (p.franchisees||[]).filter(f=>f.name&&f.email)) {
          const existingUser = (allUsers||[]).find(u => (u.email||'').toLowerCase() === (fr.email||'').toLowerCase());
          if (!existingUser) {
            const newUser = await api.createUser({ name:fr.name, email:fr.email, phone:fr.phone||'', password:'GoTutors2026!', role:'franchisee' });
            if (newUser?.id) {
              await api.sendWelcomeEmail(newUser.id);
              await api.logActivity('Auto-created franchisee user from pipeline', `${fr.name} (${fr.email})`);
            }
          }
        }
        showToast(`✓ Active branch created for ${p.companyName}`);
      }
    } catch(e) {
      showToast('Warning: auto-create failed — ' + (e.message||'unknown error'));
    }
    // Update pipeline status to active
    await api.updatePipeline(pipelineId, { ...p, status: 'active' });
    await api.logActivity('Pipeline status changed', `${p.companyName} → active`);
    setActiveModal(null);
    load();
  }
  async function markInstallmentPaid(pipelineId, idx) {
    const p = pipeline.find(x => x.id === pipelineId);
    if (!p) return;
    const updatedInstallments = (p.paymentInstallments||[]).map((inst,i) => i===idx ? {...inst, paid:true} : inst);
    await api.updatePipeline(pipelineId, { ...p, paymentInstallments: updatedInstallments });
    showToast('Marked as paid'); load();
  }
  const filtered = pipeline.filter(p => {
    const q = search.toLowerCase();
    return !q || (p.companyName||'').toLowerCase().includes(q) || (p.location||'').toLowerCase().includes(q) ||
      (p.franchisees||[]).some(f=>(f.name||'').toLowerCase().includes(q)) ||
      (p.investors||[]).some(i=>((i.name||'')+(i.companyName||'')).toLowerCase().includes(q));
  });
  // Payment reminders
  const today = new Date(); today.setHours(0,0,0,0);
  const paymentReminders = [];
  pipeline.forEach(p => {
    (p.paymentInstallments||[]).forEach((inst, idx) => {
      if (inst.paid || !inst.dueDate) return;
      const due = new Date(inst.dueDate); due.setHours(0,0,0,0);
      const daysUntil = Math.round((due - today) / 86400000);
      if (daysUntil <= 7) {
        paymentReminders.push({ pipelineId:p.id, companyName:p.companyName, location:p.location, label:inst.label, amount:inst.amount, dueDate:inst.dueDate, daysUntil, idx });
      }
    });
  });
  paymentReminders.sort((a,b) => a.daysUntil - b.daysUntil);
  const overdueReminders = paymentReminders.filter(r => r.daysUntil < 0);
  if (loading) return <div style={{ marginLeft:'var(--sidebar-width)' }}><Topbar title="Pipeline" /><Spinner /></div>;
  return (
    <div style={{ marginLeft:'var(--sidebar-width)', display:'flex', flexDirection:'column', minHeight:'100vh' }}>
      <Topbar title="Pipeline" subtitle={`${pipeline.length} entries`} actions={
        <div style={{ display:'flex', gap:8 }}>
          <div style={{ maxWidth:240 }}>
            <SearchInput value={search} onChange={setSearch} placeholder="Search..." />
          </div>
          {isAdmin && (
            <button className="btn btn-primary btn-sm" onClick={() => { setForm(emptyEntry()); setModal({mode:'new'}); }}>
              <i className="ti ti-plus" style={{ fontSize:14 }} /> Add Entry
            </button>
          )}
        </div>
      } />
      {Toast}
      {/* Payment Reminders Banner */}
      {paymentReminders.length > 0 && !isPipelineViewer && (
        <div style={{ margin:'16px 24px 0', display:'flex', flexDirection:'column', gap:8 }}>
          {overdueReminders.length > 0 && (
            <div className="card" style={{ padding:14, borderLeft:'3px solid var(--red)' }}>
              <div style={{ fontSize:11, fontWeight:700, color:'var(--red)', letterSpacing:'0.06em', marginBottom:8 }}>
                &#9888; {overdueReminders.length} OVERDUE PAYMENT{overdueReminders.length>1?'S':''}
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                {overdueReminders.map(r => (
                  <div key={r.pipelineId+'-'+r.idx} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', fontSize:13 }}>
                    <div>
                      <span style={{ fontWeight:600, color:'var(--navy)' }}>{r.location||r.companyName}</span>
                      {r.location && r.location!==r.companyName && <span style={{ color:'var(--text-tertiary)', fontSize:11 }}> &mdash; {r.companyName}</span>}
                      <span style={{ color:'var(--text-secondary)' }}> &middot; {r.label||'Payment'} &middot; &pound;{Number(r.amount||0).toLocaleString()}</span>
                    </div>
                    <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                      <span style={{ fontSize:12, fontWeight:700, color:'var(--red)' }}>{Math.abs(r.daysUntil)}d overdue</span>
                      {isAdmin && !isPipelineViewer && <button className="btn btn-sm btn-secondary" style={{ fontSize:11, padding:'3px 8px' }} onClick={() => markInstallmentPaid(r.pipelineId, r.idx)}>Mark Paid</button>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {paymentReminders.filter(r => r.daysUntil >= 0).length > 0 && (
            <div className="card" style={{ padding:14, borderLeft:'3px solid var(--amber)' }}>
              <div style={{ fontSize:11, fontWeight:700, color:'var(--amber)', letterSpacing:'0.06em', marginBottom:8 }}>
                &#128197; UPCOMING &mdash; NEXT 7 DAYS
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                {paymentReminders.filter(r => r.daysUntil >= 0).map(r => (
                  <div key={r.pipelineId+'-'+r.idx} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', fontSize:13 }}>
                    <div>
                      <span style={{ fontWeight:600, color:'var(--navy)' }}>{r.location||r.companyName}</span>
                      {r.location && r.location!==r.companyName && <span style={{ color:'var(--text-tertiary)', fontSize:11 }}> &mdash; {r.companyName}</span>}
                      <span style={{ color:'var(--text-secondary)' }}> &middot; {r.label||'Payment'} &middot; &pound;{Number(r.amount||0).toLocaleString()}</span>
                    </div>
                    <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                      <span style={{ fontSize:12, fontWeight:600, color: r.daysUntil===0?'var(--red)':r.daysUntil<=2?'var(--amber)':'var(--text-secondary)' }}>
                        {r.daysUntil===0 ? 'Due today' : 'Due in '+r.daysUntil+'d'}
                      </span>
                      {isAdmin && !isPipelineViewer && <button className="btn btn-sm btn-secondary" style={{ fontSize:11, padding:'3px 8px' }} onClick={() => markInstallmentPaid(r.pipelineId, r.idx)}>Mark Paid</button>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      {/* Kanban Board */}
      <div style={{ padding:24, flex:1, overflowX:'auto' }}>
        <div style={{ display:'flex', gap:12, minWidth:800 }}>
          {COLUMNS.map(col => {
            const colItems = filtered.filter(p => p.status === col.key);
            const isDragTarget = dragOver === col.key;
            const isCollapsible = col.key === 'not_interested';
            const isCollapsed = isCollapsible && collapsedCols[col.key];
            return (
              <div key={col.key}
                style={{ background: isDragTarget ? `${col.accent}08` : 'rgba(28,25,96,0.02)', borderRadius:'var(--r-lg)', border:`1px solid ${isDragTarget ? col.accent : 'var(--border)'}`, display:'flex', flexDirection:'column', minHeight:400, transition:'all 0.2s ease', width: isCollapsed ? 42 : 340, minWidth: isCollapsed ? 42 : 340, flexShrink:0, overflow:'hidden' }}
                onDragOver={e => { e.preventDefault(); setDragOver(col.key); }}
                onDragLeave={() => setDragOver(null)}
                onDrop={async e => { e.preventDefault(); setDragOver(null); if (dragId) { await moveToStatus(dragId, col.key); setDragId(null); } }}>
                {/* Column header */}
                {isCollapsed ? (
                  <div style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', padding:'12px 0', gap:10, cursor:'pointer' }}
                    onClick={() => setCollapsedCols(p=>({...p,[col.key]:false}))}>
                    <span style={{ fontSize:10, fontWeight:700, color:col.color, writingMode:'vertical-rl', transform:'rotate(180deg)', letterSpacing:'0.08em', whiteSpace:'nowrap' }}>{col.label}</span>
                    <span style={{ fontSize:11, fontWeight:700, color:col.accent, background:`${col.accent}22`, borderRadius:10, padding:'2px 5px' }}>{colItems.length}</span>
                    <span style={{ fontSize:12, color:'var(--text-tertiary)' }}>→</span>
                  </div>
                ) : (
                  <>
                    <div style={{ padding:'12px 14px 10px', borderBottom:'1px solid var(--border)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <span style={{ fontSize:12, fontWeight:600, color:col.color, textTransform:'uppercase', letterSpacing:'0.06em' }}>{col.label}</span>
                        <span style={{ fontSize:11, background:'#fff', border:'0.5px solid var(--border)', borderRadius:10, padding:'1px 7px', color:'var(--text-secondary)' }}>{colItems.length}</span>
                      </div>
                      {isCollapsible
                        ? <button onClick={() => setCollapsedCols(p=>({...p,[col.key]:true}))} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--text-tertiary)', fontSize:16, padding:0 }}>←</button>
                        : isAdmin && <button onClick={() => { setForm({...emptyEntry(),status:col.key}); setModal({mode:'new'}); }} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--text-tertiary)', fontSize:20, lineHeight:1 }}>+</button>
                      }
                    </div>
                    {/* Cards */}
                    <div style={{ padding:10, display:'flex', flexDirection:'column', gap:8, flex:1 }}>
                      {colItems.length === 0 && (
                        <div style={{ textAlign:'center', padding:'24px 12px', color:'var(--text-tertiary)', fontSize:12, border:'1px dashed var(--border)', borderRadius:'var(--r-md)' }}>
                          Drop here
                        </div>
                      )}
                      {colItems.map(p => {
                        const progress = CHECKBOXES.filter(c => p[c.key]).length;
                        const pct = Math.round(progress / CHECKBOXES.length * 100);
                        const allPeople = [...(p.franchisees||[]).filter(f=>f.name), ...(p.investors||[]).filter(i=>i.name||i.companyName)];
                        const hasInvestor = (p.investors||[]).some(i=>i.name||i.companyName);
                        const isExpanded = expandedId === p.id;
                        const overdueInst = (p.paymentInstallments||[]).filter(inst => {
                          if (inst.paid || !inst.dueDate) return false;
                          const due = new Date(inst.dueDate); due.setHours(0,0,0,0);
                          return due < today;
                        });
                        return (
                          <div key={p.id}
                            draggable={isAdmin && !isPipelineViewer}
                            onDragStart={() => setDragId(p.id)}
                            onDragEnd={() => setDragId(null)}
                            style={{ background:'#fff', border:`0.5px solid var(--border)`, borderLeft:`3px solid ${col.accent}`, borderRadius:`0 var(--r-md) var(--r-md) 0`, cursor:'grab', transition:'border-color 0.1s', opacity: dragId===p.id?0.5:1 }}>
                            {/* Card header */}
                            <div style={{ padding:'11px 12px 8px', cursor:'pointer' }} onClick={() => setExpandedId(isExpanded?null:p.id)}>
                              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:4 }}>
                                <div style={{ flex:1, minWidth:0 }}>
                                  <div style={{ fontWeight:600, fontSize:13, color:'var(--navy)', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{p.companyName}</div>
                                  {p.location && <div style={{ fontSize:11, color:'var(--text-tertiary)', marginTop:1 }}>{p.location}</div>}
                                </div>
                                <div style={{ display:'flex', alignItems:'center', gap:4 }}>
                                  {overdueInst.length > 0 && <span style={{ fontSize:10, color:'var(--red)', fontWeight:700 }}>⚠</span>}
                                  <i className={`ti ti-chevron-${isExpanded?'up':'down'}`} style={{ fontSize:13, color:'var(--text-tertiary)', marginLeft:2, flexShrink:0 }} />
                                </div>
                              </div>
                              {/* Progress bar */}
                              <div style={{ height:3, background:'rgba(28,25,96,0.08)', borderRadius:2, marginBottom:8, overflow:'hidden' }}>
                                <div style={{ height:'100%', borderRadius:2, width:`${pct}%`, background:pct===100?'var(--green)':col.accent, transition:'width 0.3s' }} />
                              </div>
                              {/* Footer */}
                              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                                <div style={{ display:'flex' }}>
                                  {allPeople.slice(0,4).map((person, idx) => {
                                    const c = avatarColor(idx);
                                    const name = person.name || person.companyName || '';
                                    return (
                                      <div key={idx} title={name} style={{ width:22, height:22, borderRadius:'50%', background:c.bg, color:c.color, display:'flex', alignItems:'center', justifyContent:'center', fontSize:9, fontWeight:600, border:'1.5px solid #fff', marginRight:-5 }}>
                                        {getInitials(name)}
                                      </div>
                                    );
                                  })}
                                  {allPeople.length > 4 && <div style={{ width:22, height:22, borderRadius:'50%', background:'var(--border)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:9, color:'var(--text-tertiary)', border:'1.5px solid #fff', marginRight:-5 }}>+{allPeople.length-4}</div>}
                                </div>
                                <div style={{ display:'flex', gap:4, alignItems:'center' }}>
                                  {hasInvestor && <span style={{ fontSize:10, padding:'1px 6px', borderRadius:10, background:'#EEEDFE', color:'#3C3489' }}>Investor</span>}
                                  {p.franchiseCost && <span style={{ fontSize:10, padding:'1px 6px', borderRadius:10, background:'var(--blue-bg)', color:'var(--navy)' }}>{fmt(p.franchiseCost)}</span>}
                                  <div style={{ display:'flex', gap:2 }}>
                                    {CHECKBOXES.map(c => (
                                      <div key={c.key} title={c.label} style={{ width:14, height:14, borderRadius:2, background:p[c.key]?'#C0DD97':'rgba(28,25,96,0.07)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:8, color:p[c.key]?'#27500A':'var(--text-tertiary)' }}>
                                        {p[c.key] && '✓'}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* Expanded detail */}
                            {isExpanded && (
                              <div style={{ borderTop:'1px solid var(--border)', padding:'12px 12px 10px' }}>
                                {/* Franchisees */}
                                {(p.franchisees||[]).filter(f=>f.name).length > 0 && (
                                  <div style={{ marginBottom:10 }}>
                                    <div style={{ fontSize:10, fontWeight:700, color:'var(--text-tertiary)', letterSpacing:'0.07em', marginBottom:6 }}>FRANCHISEES</div>
                                    {(p.franchisees||[]).filter(f=>f.name).map((f,i) => (
                                      <div key={i} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', fontSize:12, padding:'5px 0', borderBottom:'1px solid var(--border)' }}>
                                        <div>
                                          <div style={{ fontWeight:500 }}>{f.name}</div>
                                          {f.email && <div style={{ fontSize:11, color:'var(--text-tertiary)' }}>{f.email}</div>}
                                        </div>
                                        <div style={{ textAlign:'right' }}>
                                          {f.sharePercent && <div style={{ fontWeight:600, color:'var(--navy)' }}>{f.sharePercent}%</div>}
                                          {f.paying && <div style={{ fontSize:11, color:'var(--green)' }}>{fmt(f.paying)}</div>}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                                {/* Investors */}
                                {(p.investors||[]).filter(i=>i.name||i.companyName).length > 0 && (
                                  <div style={{ marginBottom:10 }}>
                                    <div style={{ fontSize:10, fontWeight:700, color:'var(--text-tertiary)', letterSpacing:'0.07em', marginBottom:6 }}>INVESTORS</div>
                                    {(p.investors||[]).filter(i=>i.name||i.companyName).map((inv,i) => (
                                      <div key={i} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', fontSize:12, padding:'5px 0', borderBottom:'1px solid var(--border)' }}>
                                        <div>
                                          <div style={{ fontWeight:500 }}>{inv.companyName||inv.name}</div>
                                          {inv.email && <div style={{ fontSize:11, color:'var(--text-tertiary)' }}>{inv.email}</div>}
                                        </div>
                                        <div style={{ textAlign:'right' }}>
                                          {inv.sharePercent && <div style={{ fontWeight:600, color:'var(--navy)' }}>{inv.sharePercent}%</div>}
                                          {inv.paying && <div style={{ fontSize:11, color:'var(--green)' }}>{fmt(inv.paying)}</div>}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                                {/* Checklist */}
                                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:4, marginBottom:10 }}>
                                  {CHECKBOXES.map(c => (
                                    <div key={c.key} style={{ display:'flex', alignItems:'center', gap:5, fontSize:11, padding:'4px 6px', borderRadius:'var(--r-sm)', background:p[c.key]?'var(--green-bg)':'var(--bg)' }}>
                                      <span style={{ fontSize:10, color:p[c.key]?'var(--green)':'var(--text-tertiary)' }}>{p[c.key]?'✓':'○'}</span>
                                      <span style={{ color:p[c.key]?'var(--green)':'var(--text-tertiary)' }}>{c.label}</span>
                                    </div>
                                  ))}
                                </div>
                                {/* Payment plan note */}
                                {p.paymentPlan && (
                                  <div style={{ fontSize:11, color:'var(--text-secondary)', marginBottom:8, padding:'6px 8px', background:'var(--bg)', borderRadius:'var(--r-sm)' }}>
                                    <strong>Payment:</strong> {p.paymentPlan}
                                  </div>
                                )}
                                {/* Payment installments */}
                                {(p.paymentInstallments||[]).length > 0 && (
                                  <div style={{ marginBottom:8 }}>
                                    {p.paymentInstallments.map((inst, i) => (
                                      <div key={i} style={{ display:'flex', justifyContent:'space-between', fontSize:11, padding:'4px 8px', background: inst.paid?'var(--green-bg)':'var(--bg)', borderRadius:'var(--r-sm)', marginBottom:3 }}>
                                        <span style={{ color:'var(--text-secondary)' }}>{inst.label||'Payment'} — £{Number(inst.amount||0).toLocaleString()}</span>
                                        <span style={{ color: inst.paid?'var(--green)':'var(--text-tertiary)', fontWeight:600 }}>{inst.paid?'✓ Paid':inst.dueDate?new Date(inst.dueDate).toLocaleDateString('en-GB',{day:'numeric',month:'short'}):''}</span>
                                      </div>
                                    ))}
                                  </div>
                                )}
                                {/* Comment Log */}
                                {(() => {
                                  let comments = [];
                                  try { comments = p.commentLog ? JSON.parse(p.commentLog) : (p.notes ? [{ text:p.notes, author:'Legacy note', at:'' }] : []); } catch(e) { comments = p.notes ? [{ text:p.notes, author:'Legacy note', at:'' }] : []; }
                                  return comments.length > 0 ? (
                                    <div style={{ marginBottom:8 }}>
                                      <div style={{ fontSize:10, fontWeight:700, color:'var(--text-tertiary)', letterSpacing:'0.07em', marginBottom:4 }}>NOTES & COMMENTS</div>
                                      {comments.map((c,ci) => (
                                        <div key={ci} style={{ fontSize:11, padding:'5px 8px', background:'var(--bg)', borderRadius:'var(--r-sm)', marginBottom:3, borderLeft:'2px solid var(--border)' }}>
                                          <div style={{ color:'var(--text-secondary)' }}>{c.text}</div>
                                          <div style={{ fontSize:10, color:'var(--text-tertiary)', marginTop:2 }}>{c.author}{c.at ? ' · '+new Date(c.at).toLocaleString('en-GB',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'}) : ''}</div>
                                        </div>
                                      ))}
                                    </div>
                                  ) : null;
                                })()}
                                {/* Add Comment inline */}
                                {isAdmin && (
                                  <AddComment pipelineId={p.id} user={user} onSave={async (text) => {
                                    let existing = [];
                                    try { existing = p.commentLog ? JSON.parse(p.commentLog) : (p.notes ? [{text:p.notes,author:'Legacy note',at:''}] : []); } catch(e) {}
                                    const updated = [...existing, {text, author:user?.name||user?.email||'Unknown', at:new Date().toISOString()}];
                                    await api.updatePipeline(p.id, {...p, commentLog:JSON.stringify(updated), notes:''});
                                    load();
                                  }} />
                                )}
                                {/* Timestamps */}
                                <div style={{ fontSize:10, color:'var(--text-tertiary)', marginBottom:8 }}>
                                  {p.updatedAt && p.updatedAt !== p.createdAt
                                    ? `Updated ${new Date(p.updatedAt).toLocaleString('en-GB',{day:'numeric',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit'})}`
                                    : p.createdAt ? `Created ${new Date(p.createdAt).toLocaleString('en-GB',{day:'numeric',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit'})}` : ''
                                  }
                                </div>
                                {/* Actions */}
                                {isAdmin && (
                                  <div style={{ display:'flex', gap:6 }}>
                                    <button className="btn btn-sm btn-secondary" style={{ flex:1, fontSize:11 }} onClick={e=>{e.stopPropagation();setForm({...emptyEntry(),...p,paymentInstallments:p.paymentInstallments||[],ilaSignedFranchisee:!!p.ilaSignedFranchisee,ilaSignedInvestor:!!p.ilaSignedInvestor,contractSigned:!!p.contractSigned,bankAccountOpened:!!p.bankAccountOpened,companyCreated:!!p.companyCreated,commentLog:p.commentLog||'',_newComment:''});setModal({mode:'view'});}}>View</button>
                                    {!isPipelineViewer && <button className="btn btn-sm btn-secondary" style={{ flex:1, fontSize:11 }} onClick={e=>{e.stopPropagation();setForm({...emptyEntry(),...p,paymentInstallments:p.paymentInstallments||[],ilaSignedFranchisee:!!p.ilaSignedFranchisee,ilaSignedInvestor:!!p.ilaSignedInvestor,contractSigned:!!p.contractSigned,bankAccountOpened:!!p.bankAccountOpened,companyCreated:!!p.companyCreated,commentLog:p.commentLog||'',_newComment:''});setModal({mode:'edit'});}}>Edit</button>}
                                    {!isPipelineViewer && <button className="btn btn-sm btn-danger" style={{ fontSize:11 }} onClick={e=>{e.stopPropagation();del(p);}}>Delete</button>}
                                  </div>
                                )}
                                {/* Quick status change */}
                                {isAdmin && !isPipelineViewer && (
                                  <div style={{ display:'flex', gap:4, marginTop:8, flexWrap:'wrap' }}>
                                    {COLUMNS.filter(c=>c.key!==p.status).map(c => (
                                      <button key={c.key} className="btn btn-sm" style={{ fontSize:10, padding:'3px 8px', background:'transparent', border:'1px solid var(--border)', color:'var(--text-secondary)' }}
                                        onClick={e=>{e.stopPropagation();moveToStatus(p.id,c.key);}}>
                                        → {c.label}
                                      </button>
                                    ))}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                    {/* Add button at bottom */}
                    {isAdmin && !isPipelineViewer && col.key !== 'not_interested' && (
                      <button onClick={() => { setForm({...emptyEntry(),status:col.key}); setModal({mode:'new'}); }}
                        style={{ margin:'0 10px 10px', padding:'7px', border:'1px dashed var(--border)', borderRadius:'var(--r-md)', background:'transparent', color:'var(--text-tertiary)', fontSize:12, cursor:'pointer', width:'calc(100% - 20px)' }}
                        onMouseEnter={e=>{e.currentTarget.style.borderColor='var(--navy)';e.currentTarget.style.color='var(--navy)';}}
                        onMouseLeave={e=>{e.currentTarget.style.borderColor='var(--border)';e.currentTarget.style.color='var(--text-tertiary)';}}>
                        + Add {col.label}
                      </button>
                    )}
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
      {/* Active Branch Modal */}
      {activeModal && (
        <ActiveModal
          pipelineId={activeModal.pipelineId}
          companyName={activeModal.companyName}
          location={activeModal.location}
          franchisees={activeModal.franchisees}
          onConfirm={(royaltyStart, hocUserId) => {
            handleActiveCreate(activeModal.pipelineId, royaltyStart, hocUserId || null);
          }}
          onCancel={() => setActiveModal(null)}
        />
      )}
      {/* Add/Edit Modal */}
      {modal && (
        <Modal title={modal.mode==='new'?'Add Pipeline Entry':modal.mode==='view'?'View Pipeline Entry':'Edit Pipeline Entry'} onClose={()=>setModal(null)} width={820}
          footer={modal.mode==='view'
            ? <><button className="btn btn-secondary" onClick={()=>setModal(null)}>Close</button>{!isPipelineViewer && <button className="btn btn-primary" onClick={()=>setModal({mode:'edit'})}>Edit</button>}</>
            : <><button className="btn btn-secondary" onClick={()=>setModal(null)}>Cancel</button><button className="btn btn-primary" onClick={save}>Save</button></>
          }>
          <fieldset disabled={modal.mode==='view'} style={{ border:'none', padding:0, margin:0 }}>
          <div style={{ display:'flex', flexDirection:'column', gap:12, maxHeight:'65vh', overflowY:'auto', paddingRight:4 }}>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
              <div><label>COMPANY NAME *</label><input value={form.companyName} onChange={e=>setForm(f=>({...f,companyName:e.target.value}))} placeholder="e.g. YH Learning Ltd" /></div>
              <div><label>LOCATION</label><input value={form.location||''} onChange={e=>setForm(f=>({...f,location:e.target.value}))} placeholder="e.g. Homerton Branch" /></div>
              <div><label>STATUS</label>
                <select value={form.status} onChange={e=>setForm(f=>({...f,status:e.target.value}))}>
                  {COLUMNS.map(c=><option key={c.key} value={c.key}>{c.label}</option>)}
                </select>
              </div>
              <div><label>FRANCHISE COST (£)</label><input type="number" value={form.franchiseCost||''} onChange={e=>setForm(f=>({...f,franchiseCost:e.target.value}))} /></div>
              <div style={{ gridColumn:'1/-1' }}><label>PAYMENT PLAN <span style={{ fontWeight:400, color:'var(--text-tertiary)', fontSize:10 }}>(free-text note, optional)</span></label><input value={form.paymentPlan||''} onChange={e=>setForm(f=>({...f,paymentPlan:e.target.value}))} placeholder="e.g. £36,000 immediate, £24,000 deferred" /></div>
            </div>
            {/* Payment Installments */}
            <div style={{ borderTop:'1px solid var(--border)', paddingTop:12 }}>
              <div style={{ fontSize:13, fontWeight:600, color:'var(--navy)', marginBottom:4 }}>Payment Installments</div>
              <div style={{ fontSize:11, color:'var(--text-tertiary)', marginBottom:8 }}>Add specific amounts and due dates to get reminders when payments are coming up.</div>
              {(form.paymentInstallments||[]).map((inst, i) => (
                <div key={i} style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr auto', gap:8, alignItems:'end', marginBottom:8, padding:'8px 10px', background:'var(--bg)', borderRadius:'var(--r-sm)', border:'1px solid var(--border)' }}>
                  <div><label>LABEL</label><input value={inst.label||''} onChange={e=>setForm(f=>({...f,paymentInstallments:f.paymentInstallments.map((x,j)=>j===i?{...x,label:e.target.value}:x)}))} placeholder="e.g. Deposit 1" /></div>
                  <div><label>AMOUNT (£)</label><input type="number" value={inst.amount||''} onChange={e=>setForm(f=>({...f,paymentInstallments:f.paymentInstallments.map((x,j)=>j===i?{...x,amount:e.target.value}:x)}))} /></div>
                  <div><label>DUE DATE</label><input type="date" value={inst.dueDate||''} onChange={e=>setForm(f=>({...f,paymentInstallments:f.paymentInstallments.map((x,j)=>j===i?{...x,dueDate:e.target.value}:x)}))} /></div>
                  <div style={{ display:'flex', alignItems:'center', gap:12, height:38, paddingLeft:4 }}>
                    <label style={{ display:'flex', alignItems:'center', gap:4, fontSize:12, color:'var(--text-secondary)', cursor:'pointer', userSelect:'none', fontWeight:400, textTransform:'none', letterSpacing:'normal' }}>
                      <input type="checkbox" checked={!!inst.paid} onChange={e=>setForm(f=>({...f,paymentInstallments:f.paymentInstallments.map((x,j)=>j===i?{...x,paid:e.target.checked}:x)}))} style={{ width:14, height:14, margin:0, cursor:'pointer' }} />
                      Paid
                    </label>
                    <button onClick={()=>setForm(f=>({...f,paymentInstallments:f.paymentInstallments.filter((_,j)=>j!==i)}))} style={{ background:'none', border:'none', color:'var(--red)', cursor:'pointer', fontSize:16, padding:0, lineHeight:1 }}>×</button>
                  </div>
                </div>
              ))}
              {(form.paymentInstallments||[]).length > 0 && (() => {
                const total = (form.paymentInstallments||[]).reduce((s,x) => s + (parseFloat(x.amount)||0), 0);
                const paid = (form.paymentInstallments||[]).filter(x=>x.paid).reduce((s,x) => s + (parseFloat(x.amount)||0), 0);
                const remaining = total - paid;
                return (
                  <div style={{ display:'flex', gap:16, padding:'8px 10px', background:'var(--blue-bg)', borderRadius:'var(--r-sm)', fontSize:12, marginBottom:4 }}>
                    <span><span style={{ color:'var(--text-tertiary)' }}>Total: </span><strong style={{ color:'var(--navy)' }}>£{total.toLocaleString('en-GB',{minimumFractionDigits:2,maximumFractionDigits:2})}</strong></span>
                    <span><span style={{ color:'var(--text-tertiary)' }}>Paid: </span><strong style={{ color:'var(--green)' }}>£{paid.toLocaleString('en-GB',{minimumFractionDigits:2,maximumFractionDigits:2})}</strong></span>
                    <span><span style={{ color:'var(--text-tertiary)' }}>Remaining: </span><strong style={{ color: remaining>0 ? 'var(--red)' : 'var(--green)' }}>£{remaining.toLocaleString('en-GB',{minimumFractionDigits:2,maximumFractionDigits:2})}</strong></span>
                  </div>
                );
              })()}
              <div style={{ display:'flex', gap:8, marginTop:4, flexWrap:'wrap' }}>
                <button className="btn btn-sm btn-secondary" onClick={()=>setForm(f=>({...f,paymentInstallments:[...(f.paymentInstallments||[]),{label:'',amount:'',dueDate:'',paid:false}]}))}>+ Add Single Payment</button>
                <button className="btn btn-sm btn-secondary" onClick={()=>{
                  const label = window.prompt('Label for split payments (e.g. "Monthly instalment"):', 'Monthly instalment');
                  if (!label) return;
                  const total = parseFloat(window.prompt('Total amount to split (£):') || '0');
                  if (!total || isNaN(total)) return;
                  const months = parseInt(window.prompt('Split over how many months?') || '0');
                  if (!months || isNaN(months) || months < 1) return;
                  const startDate = window.prompt('Start date (YYYY-MM-DD):', new Date(new Date().setMonth(new Date().getMonth()+1)).toISOString().split('T')[0]);
                  if (!startDate) return;
                  const monthlyAmount = (total / months).toFixed(2);
                  const newInsts = [];
                  for (let m = 0; m < months; m++) {
                    const d = new Date(startDate);
                    d.setMonth(d.getMonth() + m);
                    newInsts.push({ label: `${label} ${m+1}/${months}`, amount: monthlyAmount, dueDate: d.toISOString().split('T')[0], paid: false });
                  }
                  setForm(f=>({...f,paymentInstallments:[...(f.paymentInstallments||[]),...newInsts]}));
                }}>+ Split Over Months</button>
              </div>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:8 }}>
              {CHECKBOXES.map(c => (
                <label key={c.key} style={{ display:'flex', alignItems:'center', gap:6, cursor:'pointer', fontSize:12, padding:'8px 10px', borderRadius:'var(--r-sm)', background:form[c.key]?'var(--green-bg)':'var(--blue-bg)', border:'1px solid var(--border)' }}>
                  <input type="checkbox" checked={!!form[c.key]} onChange={e=>setForm(f=>({...f,[c.key]:e.target.checked}))} />
                  {c.label}
                </label>
              ))}
            </div>
            {/* Franchisees */}
            <div style={{ borderTop:'1px solid var(--border)', paddingTop:12 }}>
              <div style={{ fontSize:13, fontWeight:600, color:'var(--navy)', marginBottom:8 }}>Franchisees</div>
              {form.franchisees.map((fr, i) => (
                <div key={i} style={{ border:'1px solid var(--border)', borderRadius:'var(--r-md)', padding:12, marginBottom:8, background:'#fafbfd' }}>
                  <div style={{ display:'flex', justifyContent:'space-between', marginBottom:8 }}>
                    <span style={{ fontSize:12, fontWeight:500 }}>Franchisee {i+1}</span>
                    {form.franchisees.length > 1 && <button onClick={()=>setForm(f=>({...f,franchisees:f.franchisees.filter((_,j)=>j!==i)}))} style={{ background:'none', border:'none', color:'var(--red)', cursor:'pointer', fontSize:13 }}>✕</button>}
                  </div>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:8 }}>
                    <div><label>NAME</label><input value={fr.name} onChange={e=>updateFranchisee(i,'name',e.target.value)} /></div>
                    <div><label>EMAIL</label><input value={fr.email} onChange={e=>updateFranchisee(i,'email',e.target.value)} /></div>
                    <div><label>PHONE</label><input value={fr.phone} onChange={e=>updateFranchisee(i,'phone',e.target.value)} /></div>
                    <div><label>SHARE %</label><input type="number" value={fr.sharePercent} onChange={e=>updateFranchisee(i,'sharePercent',e.target.value)} /></div>
                    <div><label>PAYING (£)</label><input type="number" value={fr.paying} onChange={e=>updateFranchisee(i,'paying',e.target.value)} /></div>
                  </div>
                  {/* Documents */}
                  <div style={{ marginTop:10, borderTop:'1px solid var(--border)', paddingTop:10 }}>
                    <div style={{ fontSize:11, fontWeight:700, color:'var(--text-tertiary)', marginBottom:8, letterSpacing:'0.07em' }}>DOCUMENTS</div>
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
                      {['ID', 'Proof of Address'].map(docType => {
                        const liveDocs = complianceMap[(fr.email||'').toLowerCase().trim()];
                        const uploaded = liveDocs ? liveDocs[docType] : fr.docs?.[docType];
                        return (
                          <div key={docType}>
                            <label style={{ fontSize:11, color:'var(--text-tertiary)', display:'block', marginBottom:4 }}>{docType.toUpperCase()}</label>
                            {uploaded ? (
                              <div style={{ display:'flex', alignItems:'center', gap:6, padding:'6px 10px', background:'var(--green-bg)', borderRadius:'var(--r-sm)', border:'1px solid rgba(15,110,86,0.2)', fontSize:11 }}>
                                <span style={{ color:'var(--green)', flex:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>✓ {uploaded}</span>
                                <button onClick={() => {
                                  updateFranchisee(i, 'docs', { ...fr.docs, [docType]: null });
                                  setComplianceMap(prev => ({...prev, [(fr.email||'').toLowerCase().trim()]: {...(prev[(fr.email||'').toLowerCase().trim()]||{}), [docType]: null}}));
                                }} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--red)', fontSize:12, flexShrink:0 }}>✕</button>
                              </div>
                            ) : (
                              <label style={{ cursor:'pointer', display:'block' }}>
                                <div style={{ padding:'6px 10px', border:'1px dashed var(--border)', borderRadius:'var(--r-sm)', fontSize:11, color:'var(--text-tertiary)', textAlign:'center' }}>
                                  + Upload {docType}
                                </div>
                                <input type="file" accept=".pdf,.jpg,.jpeg,.png" style={{ display:'none' }}
                                  onChange={async e => {
                                    const file = e.target.files[0];
                                    if (!file) return;
                                    if (!fr.name || !fr.email) { showToast('Enter name and email first'); return; }
                                    let users = await api.getUsers();
                                    let existingUser = users.find(u => (u.email||'').toLowerCase() === (fr.email||'').toLowerCase());
                                    let userId;
                                    if (existingUser) { userId = existingUser.id; }
                                    else { const newUser = await api.createUser({ name:fr.name, email:fr.email, phone:fr.phone||'', password:'Welcome123!', role:'franchisee' }); userId = newUser?.id; }
                                    if (!userId) { showToast('Could not find or create user'); return; }
                                    const formData = new FormData();
                                    formData.append('file', file);
                                    await api.uploadCompliance(userId, docType, formData);
                                    updateFranchisee(i, 'docs', { ...fr.docs, [docType]: file.name });
                                    setComplianceMap(prev => ({...prev, [(fr.email||'').toLowerCase().trim()]: {...(prev[(fr.email||'').toLowerCase().trim()]||{}), [docType]: file.name}}));
                                    showToast(`${docType} uploaded to compliance`);
                                    e.target.value = '';
                                  }} />
                              </label>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              ))}
              <button className="btn btn-sm btn-secondary" onClick={()=>setForm(f=>({...f,franchisees:[...f.franchisees,emptyPerson('franchisee')]}))}>+ Add Franchisee</button>
            </div>
            {/* Investors */}
            <div style={{ borderTop:'1px solid var(--border)', paddingTop:12 }}>
              <div style={{ fontSize:13, fontWeight:600, color:'var(--navy)', marginBottom:8 }}>Investors</div>
              {form.investors.map((inv, i) => (
                <div key={i} style={{ border:'1px solid var(--border)', borderRadius:'var(--r-md)', padding:12, marginBottom:8, background:'#fafbfd' }}>
                  <div style={{ display:'flex', justifyContent:'space-between', marginBottom:8 }}>
                    <span style={{ fontSize:12, fontWeight:500 }}>Investor {i+1}</span>
                    <div style={{ display:'flex', gap:8 }}>
                      <label style={{ display:'flex', alignItems:'center', gap:4, fontSize:11, cursor:'pointer' }}>
                        <input type="radio" name={`invtype_${i}`} checked={inv.type==='individual'} onChange={()=>updateInvestor(i,'type','individual')} /> Individual
                      </label>
                      <label style={{ display:'flex', alignItems:'center', gap:4, fontSize:11, cursor:'pointer' }}>
                        <input type="radio" name={`invtype_${i}`} checked={inv.type==='company'} onChange={()=>updateInvestor(i,'type','company')} /> Company
                      </label>
                      <button onClick={()=>setForm(f=>({...f,investors:f.investors.filter((_,j)=>j!==i)}))} style={{ background:'none', border:'none', color:'var(--red)', cursor:'pointer', fontSize:13 }}>✕</button>
                    </div>
                  </div>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:8 }}>
                    {inv.type==='company' && <div style={{ gridColumn:'1/-1' }}><label>COMPANY NAME</label><input value={inv.companyName||''} onChange={e=>updateInvestor(i,'companyName',e.target.value)} /></div>}
                    <div><label>CONTACT NAME</label><input value={inv.name} onChange={e=>updateInvestor(i,'name',e.target.value)} /></div>
                    <div><label>EMAIL</label><input value={inv.email} onChange={e=>updateInvestor(i,'email',e.target.value)} /></div>
                    <div><label>PHONE</label><input value={inv.phone} onChange={e=>updateInvestor(i,'phone',e.target.value)} /></div>
                    <div><label>SHARE %</label><input type="number" value={inv.sharePercent} onChange={e=>updateInvestor(i,'sharePercent',e.target.value)} /></div>
                    <div><label>PAYING (£)</label><input type="number" value={inv.paying} onChange={e=>updateInvestor(i,'paying',e.target.value)} /></div>
                  </div>
                </div>
              ))}
              <button className="btn btn-sm btn-secondary" onClick={()=>setForm(f=>({...f,investors:[...f.investors,emptyPerson('investor')]}))}>+ Add Investor</button>
            </div>
            {/* Comment Log in modal */}
            <div style={{ gridColumn:'1/-1' }}>
              <label>NOTES & COMMENTS</label>
              {(() => {
                let comments = [];
                try { comments = form.commentLog ? JSON.parse(form.commentLog) : (form.notes ? [{ text:form.notes, author:'Legacy note', at:'' }] : []); } catch(e) { comments = form.notes ? [{ text:form.notes, author:'Legacy note', at:'' }] : []; }
                return (
                  <div>
                    {comments.length > 0 && (
                      <div style={{ marginBottom:8, maxHeight:140, overflowY:'auto' }}>
                        {comments.map((c,ci) => (
                          <div key={ci} style={{ fontSize:11, padding:'5px 8px', background:'var(--bg)', borderRadius:'var(--r-sm)', marginBottom:3, borderLeft:'2px solid var(--border)' }}>
                            <div style={{ color:'var(--text-secondary)' }}>{c.text}</div>
                            <div style={{ fontSize:10, color:'var(--text-tertiary)', marginTop:2 }}>{c.author}{c.at ? ' · '+new Date(c.at).toLocaleString('en-GB',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'}) : ''}</div>
                          </div>
                        ))}
                      </div>
                    )}
                    <div style={{ display:'flex', gap:6 }}>
                      <textarea
                        value={form._newComment||''}
                        onChange={e=>setForm(f=>({...f,_newComment:e.target.value}))}
                        placeholder="Add a comment..."
                        rows={2}
                        style={{ resize:'none', flex:1 }}
                      />
                      <button className="btn btn-sm btn-primary" style={{ alignSelf:'flex-end', whiteSpace:'nowrap' }}
                        onClick={() => {
                          if (!(form._newComment||'').trim()) return;
                          let existing = [];
                          try { existing = form.commentLog ? JSON.parse(form.commentLog) : (form.notes ? [{ text:form.notes, author:'Legacy note', at:'' }] : []); } catch(e) {}
                          const newComment = { text:form._newComment.trim(), author:user?.name||user?.email||'Unknown', at:new Date().toISOString() };
                          const updated = [...existing, newComment];
                          setForm(f=>({...f, commentLog:JSON.stringify(updated), _newComment:'', notes:'' }));
                        }}>
                        Add
                      </button>
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
          </fieldset>
        </Modal>
      )}
    </div>
  );
}
